/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CommandSucceededNotification { 
    command_id?: string;
    command_type?: string;
    request_id?: string;
    trace_identifier?: string;
    object_type?: string;
    object_id?: string;
    user_id?: string;
    notification_type?: string;
}

